module.exports = __webpack_public_path__ + "img/pam_didner.jpeg";